module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/navigation/arrow-up-093b36fde5b793b82fdf795b962accb8.svg";